// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__PF9fY","photoBlock":"Message_photoBlock__uAQbr","photoImg":"Message_photoImg__rvUhi"};